import React from 'react';
import CombinedLandingPage from './CombinedLandingPage';
const ContactPage = React.lazy(() => import('./ContactPage'));
const NewsletterPage = React.lazy(() => import('./NewsletterPage'));

export { CombinedLandingPage, ContactPage, NewsletterPage };
